export const ENVIRONMENT_NAMES = ['local', 'integration1', 'integration5', 'production', 'uat'] as const;
export type EnvironmentName = (typeof ENVIRONMENT_NAMES)[number];
